import { DAY_UNIT } from '../constants';

import leaveTypePickerComponent from './leaveTypePickerComponent.html';

class LeaveTypePickerCtrl {
  constructor(LeaveService, Authentication, $q) {
    'ngInject';

    Object.assign(this, { LeaveService, Authentication, $q });
  }

  async $onInit() {
    this.usersLeaveStatus = {};
    this.currentUserLeaveStatus = {};
    this.paidSummary = '0';

    this.setTypes();
    this.setSelectedTypeName();
    await this.getUserSpecificData();
    this.setSummaries();
  }

  async $onChanges({ userId: userIdChange, date: dateChange, timeOffTypes: timeOffTypesChange }) {
    // !isFirstChange due to https://github.com/angular/angular.js/issues/15515
    if (
      (userIdChange && !userIdChange.isFirstChange()) ||
      (dateChange && !dateChange.isFirstChange())
    ) {
      await this.getUserSpecificData();
      this.setSummaries();
    }

    if (
      timeOffTypesChange &&
      !timeOffTypesChange.previousValue.length &&
      timeOffTypesChange.currentValue
    ) {
      this.setTypes();
    }
  }

  async getUserSpecificData() {
    this.loading = true;
    const userSpecificDataToFetch = [this.setUsersLeaveStatus()];

    try {
      await this.$q.all(userSpecificDataToFetch);
    } finally {
      this.loading = false;
    }
  }

  get workDayHours() {
    const workDayMinutes = this.LeaveService.workDayMinutes;
    return Math.floor(workDayMinutes / 60);
  }

  get isGlobal() {
    return this.LeaveService.isGlobal;
  }

  setTypes() {
    this.timeOffTypesPaid = this.timeOffTypes
      .filter((type) => type.paid)
      .map((type) => ({ ...type }));
    this.timeOffTypesUnpaid = this.timeOffTypes
      .filter((type) => !type.paid)
      .map((type) => ({ ...type }));
  }

  async setUsersLeaveStatus() {
    if (!this.userId) {
      this.currentUserLeaveStatus = {};
      return;
    }

    this.usersLeaveStatus[this.userId] = await this.LeaveService.getUserLeavesStatus(
      this.userId,
      this.date
    );
    this.currentUserLeaveStatus = this.usersLeaveStatus[this.userId];
  }

  onTypeClick(timeOffType) {
    this.selectedTypeName = timeOffType.name;
    this.updateType({ timeOffType });
  }

  setSummaries() {
    const paidMinutes = this.LeaveService.getPaidLeavesDuration(this.currentUserLeaveStatus);
    const unpaidMinutes = this.LeaveService.getUnpaidLeavesDuration(this.currentUserLeaveStatus);

    if (this.isGlobal) {
      const globalCap = this.LeaveService.getGlobalCap(this.userLeaveCaps);
      const displayUnit = this.LeaveService.units === DAY_UNIT ? 'days' : 'hours';
      this.paidSummary = `${this.LeaveService.getDecimalLabel(paidMinutes)} / ${globalCap}`;
      this.paidTooltip = `Taken ${this.LeaveService.getDescriptiveLabel(
        paidMinutes
      )} of ${globalCap} ${displayUnit}`;

      this.unpaidSummary = this.LeaveService.getDecimalLabel(unpaidMinutes);
      this.unpaidTooltip = `Taken ${this.LeaveService.getDescriptiveLabel(
        unpaidMinutes
      )} of unlimited ${displayUnit}`;
    }
  }

  get isLimitReached() {
    if (this.isGlobal) {
      const paidMinutes = this.LeaveService.getPaidLeavesDuration(this.currentUserLeaveStatus);
      const cap =
        this.LeaveService.units === DAY_UNIT
          ? this.LeaveService.globalCap * this.LeaveService.workDayMinutes
          : this.LeaveService.globalCap * 60;
      return paidMinutes >= cap;
    }
    return false;
  }

  isPickerDisabled() {
    return this.Authentication.user && !this.Authentication.isOrgFeatureEnabled('leaveTypes');
  }

  setSelectedTypeName() {
    this.selectedTypeName = this.timeOffType ? this.timeOffType.name : '';
  }
}

export default {
  bindings: {
    timeOffType: '=',
    userId: '<?',
    date: '<',
    updateType: '&',
    userLeaveCaps: '<',
    timeOffTypes: '<',
  },
  controllerAs: 'ctrl',
  controller: LeaveTypePickerCtrl,
  templateUrl: leaveTypePickerComponent,
};
